import React from "react";

function capitalizeFirstLetters(string) {
  return string.replace(/\b\w/g, (char) => char.toUpperCase());
}

const CapitalizeText = ({ children }) => {
  return <span>{capitalizeFirstLetters(children)}</span>;
};

export default CapitalizeText;
